export enum CommercialRoute {
  empty = '',
  contracts = 'contracts',
  prospects = 'prospects',
  clientGeneralLedger = 'client-general-ledger'
}
